// extracted by mini-css-extract-plugin
module.exports = {"prompt":"CheckPhish_prompt__maT_I","phishForm":"CheckPhish_phishForm__Qp0rt","subjectInput":"CheckPhish_subjectInput__2u7Jt","check":"CheckPhish_check__HEerH"};